import React from 'react'

export default class ReservationTableJobAssignmentColumn
  extends React.Component
{
  createHandleAssignClick = (jobAssignment) => () => {
    this.props.onAssignClick(this.props.reservation, jobAssignment)
  }

  createHandleAcceptClick = (jobAssignment) => () => {
    this.props.onAcceptClick(this.props.reservation, jobAssignment)
  }

  render() {
    const { jobAssignments } = this.props
    return (
      <div className="border border-gray-200 rounded-lg overflow-hidden">
        {jobAssignments &&
          jobAssignments.map((jobAssignment) => (
            <ReservationTableJobAssignmentColumnItem
              key={jobAssignment._id}
              firstName={jobAssignment.staff.firstName}
              lastName={jobAssignment.staff.lastName}
              displayName={jobAssignment.service.displayName}
              status={jobAssignment.status}
              onAssignClick={this.createHandleAssignClick(jobAssignment)}
              onAcceptClick={this.createHandleAcceptClick(jobAssignment)}
            />
          ))}
      </div>
    )
  }
}

const ReservationTableJobAssignmentColumnItem = ({
  firstName,
  lastName,
  displayName,
  status,
  onAssignClick,
  onAcceptClick,
}) => {
  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case 'pending':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200'
      case 'accepted':
        return 'bg-green-100 text-green-800 border-green-200'
      case 'completed':
        return 'bg-blue-100 text-blue-800 border-blue-200'
      case 'cancelled':
        return 'bg-red-100 text-red-800 border-red-200'
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200'
    }
  }

  return (
    <div className="px-4 py-3 border-b border-gray-200 last:border-b-0 bg-white">
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <div className="text-base text-gray-900 mb-1">
            {firstName} {lastName}
          </div>
          <div className="text-sm text-gray-700">
            <strong>{displayName}</strong>
          </div>
        </div>
        <div className="flex flex-col items-end gap-2">
          <span
            className={`inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-semibold border ${getStatusColor(status)}`}
          >
            {status.toUpperCase()}
          </span>
          <div className="flex gap-1">
            <button
              onClick={onAssignClick}
              className="p-2 bg-yellow-500 hover:bg-yellow-600 text-white rounded transition-colors"
              aria-label="Reassign"
              title="Reassign"
            >
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                />
              </svg>
            </button>
            {status === 'pending' && (
              <button
                onClick={onAcceptClick}
                className="p-2 bg-green-500 hover:bg-green-600 text-white rounded transition-colors"
                aria-label="Accept"
                title="Accept"
              >
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
